export default __webpack_public_path__ + "static/media/ic_target_completed.19febe14.svg";